import { takeLatest } from 'redux-saga/effects';
import { REPORTS_PAGE_MODULE } from '../../../configs/moduleNames';
import { EXPORT, EXPORT_STATUS, LOAD_REPORTS_LIST } from '../actions';
import loadReportsList from './loadReportsList';
import exportReports from './exportReports';
import exportReportsStatus from './exportReportsStatus';

export default function* sagas() {
  yield takeLatest(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST, loadReportsList);
  yield takeLatest(REPORTS_PAGE_MODULE + EXPORT, exportReports);
  yield takeLatest(REPORTS_PAGE_MODULE + EXPORT_STATUS, exportReportsStatus);
}
